import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Activity, Compass } from 'lucide-react';
import DynamicOnboardingWizard from '@/components/DynamicOnboardingWizard';

export default function OnboardingPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--bg, #fbfbfd)',
        color: 'var(--text, #0a0a0b)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Top Header */}
      <header
        style={{
          borderBottom: '1px solid var(--border, #e8e8ed)',
          background: 'rgba(255,255,255,0.9)',
          backdropFilter: 'blur(16px)',
          padding: '16px 28px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: 'var(--text-secondary, #6b6b76)',
              fontSize: '13.5px',
              fontWeight: 700,
            }}
          >
            <ArrowLeft size={16} /> Exit to Arena
          </button>
          <span style={{ color: 'var(--border, #e8e8ed)' }}>|</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 900, fontSize: '15px' }}>
            <Activity size={18} color="#7c3aed" /> KhelDrop Player Passport
          </div>
        </div>

        <button
          onClick={() => {
            if (typeof window !== 'undefined') {
              window.dispatchEvent(new CustomEvent('kheldrop_start_tour'));
            }
            navigate('/');
          }}
          style={{
            background: 'rgba(124, 58, 237, 0.08)',
            border: '1px solid rgba(124, 58, 237, 0.25)',
            color: '#7c3aed',
            borderRadius: '999px',
            padding: '6px 14px',
            fontSize: '12.5px',
            fontWeight: 800,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          <Compass size={14} /> Interactive App Tour
        </button>
      </header>

      {/* Main Container */}
      <main
        style={{
          flex: 1,
          maxWidth: '1120px',
          width: '100%',
          margin: '32px auto 60px',
          padding: '0 20px',
        }}
      >
        <div
          style={{
            background: '#ffffff',
            borderRadius: '28px',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0,0,0,0.04)',
            overflow: 'hidden',
          }}
        >
          <DynamicOnboardingWizard isModal={false} />
        </div>
      </main>
    </div>
  );
}
